import React, { useState } from 'react';
import { BUTTON_SIZES, BUTTON_VARIANTS, Button } from 'ui/button';
import { FileDropzone } from 'ui/fileDropzone';
import { Modal, ModalFooter, ModalBody, ModalHeader, MODAL_SIZES, MODAL_VARIANTS } from 'ui/modal';

interface CSVImportModalProps {
  isOpen: boolean;
  onClose: () => void;
  onImport: (data: string) => void;
}

export const CSVImportModal: React.FC<React.PropsWithChildren<CSVImportModalProps>> = ({
  isOpen,
  onClose,
  onImport,
}) => {
  const [csvData, setCsvData] = useState('');

  const handleFileUpload = (acceptedFiles: File[]) => {
    const file = acceptedFiles[0];
    if (file) {
      const reader = new FileReader();
      reader.onload = (e) => {
        const text = e.target?.result?.toString();
        if (text) {
          setCsvData(text);
        }
      };
      reader.readAsText(file);
    }
  };

  const handleImport = () => {
    onImport(csvData);
    onClose();
  };

  return (
    <Modal
      id="csv-import-modal"
      isModalOpen={isOpen}
      onClose={onClose}
      size={MODAL_SIZES.MEDIUM}
      variant={MODAL_VARIANTS.DEFAULT}
    >
      <ModalHeader id="csv-import-modal-header" onClose={onClose}>
        Import CSV
      </ModalHeader>
      <ModalBody id="csv-import-modal-body">
        <FileDropzone
          accept={{ 'text/csv': ['.csv'] }}
          onUpload={handleFileUpload}
          multiple={false}
        />
      </ModalBody>
      <ModalFooter id="csv-import-modal-footer" onClose={onClose}>
        <Button onClick={handleImport} size={BUTTON_SIZES.LARGE} variant={BUTTON_VARIANTS.PRIMARY}>
          Import CSV
        </Button>
      </ModalFooter>
    </Modal>
  );
};
